import { defineElement } from '@webtides/element-js';
import TrackingElement from '../../../elements/tracking/TrackingElement';
import pushCustomTrackingEvent from '../../../elements/tracking/helpers/pushCustomTrackingEvent';
import RetailerSearchEvents from './RetailerSearchEvents';

class RetailerSearchTracking extends TrackingElement {
    connected() {
        super.connected();

        this.$trackingTarget.addEventListener(
            RetailerSearchEvents.FETCHING_RETAILERS_CHANGED,
            ({ detail: fetchingRetailers }) => {
                if (fetchingRetailers === false) {
                    this.trackRetailerSearch(this.$trackingTarget.locationSearchString, this.$trackingTarget.retailers);
                }
            },
        );
    }

    getTrackingTarget() {
        return document.querySelector('retailer-search');
    }

    trackRetailerSearch(searchString, retailers) {
        pushCustomTrackingEvent({
            action: searchString,
            category: 'retailer search',
            label: retailers.length,
        });
    }
}

defineElement('retailer-search-tracking', RetailerSearchTracking);
